import { safePosthogFeatureFlags } from "./postHog";

export enum FeatureFlag {
  ApolloCachePersistor = "apollo-cache-persistor",
  ConfirmProvisionedRipplingEmployees = "confirm-provisioned-rippling-employees",
  DashboardFsReportsWithStatus = "dashboard-fs-reports-with-status",
  DashboardShowPercentageChanged = "dashboard-show-percentage-changed",
  DecimalSecondaryDashboardCharts = "decimal-secondary-dashboard-charts",
  DevOnlyFlagOverrideNonFirmOwnerCheck = "dev-only-flag-override-non-firm-only-check",
  DynamicCrossSell = "dynamic-cross-sell",
  EnableEventBreakout = "enable-event-breakout",
  EveryIntegrationVisible = "every-integration-visible",
  FeatureOnboardingRules = "feature-onboarding-rules",
  FStoFilteredGL = "fs_to_filtered_gl",
  GeneralLedgerMRT = "general-ledger-mrt",
  GeneralLedgerEmptyState = "general-ledger-empty-state",
  GroupCategoriesByAccount = "group-categories-by-account",
  HistoricalBooksV2 = "historical-books-v2",
  IntroFlowNewOnboardingFunnel = "intro-flow-new-onboarding-funnel",
  MapAccountToCoa = "map-account-to-coa",
  MultipleIntegrationConnections = "multiple-integration-connections",
  SetStripeEpoch = "set-stripe-epoch",
  SkipTrial = "skip-trial",
  BulkClassifyTransactions = "bulk-classify-transactions",
  SplitsV2 = "splits-v2",
  PhoneNumberInput = "phone-number-input",
  ClassificationRules = "classification-rules",
  AccuracyReviewSetting = "accuracy-review-setting",
  ActiveCompanyLogging = "active-company-logging",
  PhoneNumberRequiredTest = "phone-number-required-test",
  UseCategoryDropdown = "use-category-dropdown",
  EnableChurnkey = "enable-churnkey",
  TransactionsNoFIEmptyStates = "transactions-no-fi-empty-states",
  SidebarAddReviewMenu = "sidebar-add-review-menu",
  SidebarPartialMinimized = "sidebar-partial-minimized",
  UnconfirmContractLinesWithoutSchedules = "unconfirm-contract-lines-without-schedules",
  RedirectLogging = "redirect-logging",
  FirmSelect = "firm-select",
  CrossSellFondoToCCorps = "cross-sell-fondo-to-ccorps",
  CrossSellFondoToAllCompanies = "cross-sell-fondo-to-all-companies",
  CrossSellGustoToCompaniesWithoutPayroll = "cross-sell-gusto-to-companies-without-payroll",
  CrossSellGustoToAllCompanies = "cross-sell-gusto-to-all-companies",
  CrossSellBrexToAllCompanies = "cross-sell-brex-to-all-companies",
  CrossSellBrexToCompaniesWithoutCreditCard = "cross-sell-brex-to-companies-without-credit-card",
  OnboardingLaunchpadForceBrex = "onboarding-launchpad-force-brex",
  RecurringMjeSchedulesEndDateEditable = "recurring-mje-schedules-end-date-editable",
  MjeGroupsInNav = "mje-groups-in-nav",
  OnboardingLaunchpadCheckBrex = "onboarding-launchpad-check-brex",
  StripeDetailDateFilter = "stripe-detail-date-filter",
  RevenueInsightsFeatureGate = "revenue-insights-feature-gate",
  ManualJournalsEdit = "mje-edit",
}

// Manually override flags to be enabled on local + dev for testing
export const FLAGS_ENABLED_ON_DEV = [
  FeatureFlag.ApolloCachePersistor,
  FeatureFlag.SetStripeEpoch,
  FeatureFlag.GeneralLedgerMRT,
  FeatureFlag.MapAccountToCoa,
  FeatureFlag.PhoneNumberInput,
  FeatureFlag.ClassificationRules,
  // FeatureFlag.IntroFlowNewOnboardingFunnel, // For testing new onboarding funnel
  // FeatureFlag.ActiveCompanyLogging, // turn on for logging in local development
  // FeatureFlag.RedirectLogging, // turn on for logging in local development
  // FeatureFlag.HistoricalBooksV2, // for testing new historical books
  FeatureFlag.BulkClassifyTransactions,
  FeatureFlag.AccuracyReviewSetting,
  FeatureFlag.EnableChurnkey,
  FeatureFlag.UnconfirmContractLinesWithoutSchedules,
  FeatureFlag.EveryIntegrationVisible,
  FeatureFlag.RecurringMjeSchedulesEndDateEditable,
  FeatureFlag.MjeGroupsInNav,
  FeatureFlag.StripeDetailDateFilter,
  FeatureFlag.ManualJournalsEdit,
];

// Manually override flags to be enabled on staging
// Careful! staging is used for demos, make sure the feature is suited for a demo environment
export const FLAGS_ENABLED_ON_STAGING = [];

export const isPosthogFeatureFlagEnabled = (featureFlag: FeatureFlag) => {
  // this allows for setting permanent feature flags in the ENV (local or otherwise)
  // presence of the var == flag set globally
  if (process.env["FFLAG_" + (featureFlag as string).replace("-", "_").toUpperCase()]) {
    return true;
  }
  return safePosthogFeatureFlags()?.isFeatureEnabled(featureFlag, { send_event: false });
};

export const reloadFeatureFlags = () => {
  safePosthogFeatureFlags()?.reloadFeatureFlags();
};

export const getFeatureFlag = (featureFlag: FeatureFlag) => {
  return safePosthogFeatureFlags()?.getFeatureFlag(featureFlag);
};
